export enum OrderPaymentStatus {
  Unpaid = 'UNPAID',
  Paid = 'PAID',
  Failed = 'FAILED',
  Pending = 'PENDING',
}
